<template>
  <div class="panel">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.panel {
  box-sizing: border-box;
  width: 100%;
  padding: $spacing-unit * 2;
  background: $text-color-white;
  border: 1px solid $border-color;
  border-radius: $round;
}
</style>
